<template>
    <b-button 
        v-if="mostrarBtnCancelar"
        class="ml-2"
        variant="danger" 
        @click.stop="confirmarCancelamento()"
    >
        <span> <i class="fa fa-ban mr-2"></i> Cancelar Despesa </span>
    </b-button>
</template>

<script>
import { StatusDespesa } from '../../componentes/despesas/StatusDespesa'

export default {
    props: {
        despesa: {
            type: Object
        },

        servicos: {
            type: Object
        }
    },

    methods: {
        confirmarCancelamento() {
            this.$swal({
                title: 'Cancelar despesa',
                html: `Confirma o <strong>CANCELAMENTO</strong> da despesa?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa do cancelamento',
                inputValidator: value => {
                    if (!value) {
                        return 'A justificativa do cancelamento é obrigatória'
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.cancelar(result.value)
                }
            })
        },

        cancelar(justificativa) {
            this.$store.dispatch('addRequest')
            let justificativaDto = {
                'justificativa': justificativa
            }
            this.servicos.cancelar(this.despesa.despesaId, justificativaDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Despesa cancelada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterDespesa')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        mostrarBtnCancelar() {
            return this.despesa.pagamentoPermiteCancelar
                && ((this.$route.name == 'DespesasGerais_Requisitantes_Despesas_Detalhar'
                    && this.$temAcessoView('DESP-GERAIS-REQ-06')
                    && (this.despesa.statusId == StatusDespesa.CRIADA
                        || this.despesa.statusId == StatusDespesa.REPROVADA_POR_DEMANDANTE
                        || this.despesa.statusId == StatusDespesa.REPROVADA_POR_GERENTE
                        || this.despesa.statusId == StatusDespesa.REPROVADA_PELA_UABS
                        || this.despesa.statusId == StatusDespesa.APROVADA)
                    && this.despesa.codSolicitante.slice(2) === this.$store.getters.usuario.login.slice(2))
                || (this.$route.name == 'DespesasGerais_Finalizacao_Despesas_Detalhar'
                    && this.$temAcessoView('DESP-GERAIS-FINAL-03')
                    && this.despesa.statusId == StatusDespesa.APROVADA
                ))
        }
    }
}

</script>